import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { JobSearchApp } from './components/job-search-app'
import { IJobSearchPageContent, DefaultJobSearchPageContent } from './models/content';
import { ContentApiState, contentApiReducerWithDefault } from '../global/ducks/content-api';
import { JobSearchApiState, jobSearchApiReducer } from '../global/ducks/job-search-api';
import { fetchMiddleware } from '../global/middleware/fetch-middleware';
import { Query } from '../global/functions/query';

export interface IJobSearchAppState {
    contentState: ContentApiState<IJobSearchPageContent>
    searchResults: JobSearchApiState
}

export const rootReducer = combineReducers<IJobSearchAppState>({
    contentState: contentApiReducerWithDefault({ props: DefaultJobSearchPageContent }),
    searchResults: jobSearchApiReducer
})

window.addEventListener("DOMContentLoaded", () => {
    const mount = document.getElementById('jobSearchAppRoot');
    const contentId = (window as any).bootstrap.contentId;
    const businessAreas = (window as any).bootstrap.businessAreas;
    const cities = (window as any).bootstrap.cities;
    const states = (window as any).bootstrap.states;
    const countries = (window as any).bootstrap.countries;

    // Attach Redux extension and add any middleware (just fetch here)
    const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    const store = createStore(rootReducer, composeEnhancers(
        applyMiddleware(
            fetchMiddleware,
        )
    ));

    if (mount) {
        ReactDOM.render(
            <Provider store={store}>
                <JobSearchApp
                    contentId={contentId}
                    cities={cities}
                    businessAreas={businessAreas}
                    states ={states}
                    countries={countries}
                    initialParams={Query.getParams()}
                    setQueryParams={Query.setParams}
                />
            </Provider>, mount);
    }
});